import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from 'components/system/layouts/Layout';
import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import ScreenContext from 'Contexts/Common/ScreenContext';
import COMMON from 'constants/common';
import redirectLinks from 'constants/redirectLinks';
import ReturnButton from 'components/system/atoms/buttons/ReturnButton';
import GroupConfTopButton from 'components/group/atoms/buttons/GroupConfTopButton';
import { useAppDispatch } from 'redux/hooks';
import {
  setNextFromLedOrderSetScr,
  setNextFromOrderSetScr,
} from 'redux/slices/groupSlice';

/* ************ Context ************ */
// title componetに渡す値
const ScreenContextValue = {
  title: 'グループカテゴリー選択',
  screenId: 'SCR412',
  currentMenu: COMMON.MENU.GROUP,
};

/* ************ Style ************ */
const useStyles = makeStyles()(() => ({
  content: {
    height: '598px',
    width: '1140px',
    padding: '24px 0px 0px 4px',
  },
  topArea: {
    display: 'flex',
    justifyContent: 'flex-start',
    '& .returnButton': {
      padding: '4px 0px 0px 24px',
      width: '224px',
    },
  },
  mainArea: {
    paddingLeft: '235px',
    flexDirection: 'row',
  },
}));

const GroupSelectCategory: React.FC<React.PropsWithChildren<unknown>> = () => {
  const navigate = useNavigate();
  const { classes } = useStyles();
  const dispatch = useAppDispatch();

  const handleClickGroupConfTop = () => {
    navigate(redirectLinks.GROUP_CONF_TOP);
  };
  const handleClickGroupLEDConf = () => {
    dispatch(setNextFromLedOrderSetScr(COMMON.SCREEN_ID.GROUP_SELECT_CATEGORY));
    navigate(redirectLinks.GROUP_LED_GROUP_CREATE, {
      state: { fromScrId: COMMON.SCREEN_ID.GROUP_SELECT_CATEGORY },
    });
  };
  const handleClickPremiumConf = () => {
    dispatch(setNextFromOrderSetScr(COMMON.SCREEN_ID.GROUP_SELECT_CATEGORY));
    navigate(redirectLinks.GROUP_GET_GIFT_GROUP_CREATE, {
      state: { fromScrId: COMMON.SCREEN_ID.GROUP_SELECT_CATEGORY },
    });
  };

  return (
    <ScreenContext.Provider value={ScreenContextValue}>
      <Layout>
        <Box className={classes.content}>
          <Box className={classes.topArea}>
            <Box className="returnButton">
              <ReturnButton onClick={handleClickGroupConfTop}>
                グループ
                <br />
                設定TOP
              </ReturnButton>
            </Box>
          </Box>
          <Box className={classes.mainArea}>
            <GroupConfTopButton onClick={handleClickGroupLEDConf} iconName="iconLED" />
            <GroupConfTopButton onClick={handleClickPremiumConf} iconName="iconInCommsSetting" />
          </Box>
        </Box>
      </Layout>
    </ScreenContext.Provider>
  );
};

export default GroupSelectCategory;
